import { NgModule } from "@angular/core";
import { LoadSpinner } from "./load-spinner/load-spinner.component";
import { CommonModule } from '@angular/common';
import { SlideOutComponent } from './slide-out/slide-out.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { ErrorHandlerComponent } from './error-handler/error-handler.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
  declarations: [LoadSpinner, SlideOutComponent, ErrorHandlerComponent],
  imports:
  [
    CommonModule,
    SelectDropDownModule,
    NgbModule,
    NgxJsonViewerModule
  ],
  exports: [LoadSpinner, SlideOutComponent, ErrorHandlerComponent]
})
export class SharedComponentsModule { }
